/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClimateCalculationKeys } from '../../models/climate-calculation-keys';

export interface ClimateCalculationKeysGet$Params {
}

export function climateCalculationKeysGet(http: HttpClient, rootUrl: string, params?: ClimateCalculationKeysGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ClimateCalculationKeys>> {
  const rb = new RequestBuilder(rootUrl, climateCalculationKeysGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClimateCalculationKeys>;
    })
  );
}

climateCalculationKeysGet.PATH = '/climateCalculationKeys';
